module.exports = __webpack_public_path__ + "static/media/vcoach-2people.73ca7c8f.png";